import type { CSSProperties } from 'react'
import { VideoFilePlayer } from './VideoFilePlayer'
import { VideoStreamPlayer } from './VideoStreamPlayer'

type Props = {
  src: string
  poster?: string
  className?: string
  style?: CSSProperties
  onError?: (error: string) => void
}

export function VideoPlayer({ src, poster, className, style, onError }: Props) {
  if (src.includes('.m3u8')) {
    return (
      <VideoStreamPlayer
        className={className}
        style={style}
        src={src}
        poster={poster}
        onError={onError}
      />
    )
  }

  return (
    <VideoFilePlayer
      className={className}
      style={style}
      src={src}
      poster={poster}
      onError={onError}
    />
  )
}
